import 'swiper/css/bundle';
import Swiper from 'swiper';

import './sustainability.scss';

const sustainability = () => {
    document.addEventListener('DOMContentLoaded', function () {
        const sustainabilityModals = document.querySelectorAll('.sustainability-modal');
        const openModalButtons = document.querySelectorAll('.sustainability-card > .open-modal');
        const closeSustainabilityModals = document.querySelectorAll('.sustainability-modal .close-wrapper');

        let args = {
            slidesPerView: 3,
            spaceBetween: 40,
            centeredSlides: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    centeredSlides: false,
                    spaceBetween: 10,
                },
                767: {
                    slidesPerView: 2.2,
                    centeredSlides: false,
                    spaceBetween: 30,
    
                },
                992: {
                  slidesPerView: 3,
                  centeredSlides: false,
                  spaceBetween: 40,
                }
            },
        };

        let sustainabilitySwiper = new Swiper(document.querySelector('.sustainabilitySwiper'), args);

        openModalButtons.forEach((button, index) => {
            button.addEventListener('click', function () {
                sustainabilityModals[index].style.display = 'flex';
            });
        });

        closeSustainabilityModals.forEach((closeButton, index) => {
            closeButton.addEventListener('click', function () {
                sustainabilityModals[index].style.display = 'none';
            });
        });

        window.addEventListener('click', function (event) {
            sustainabilityModals.forEach((modal) => {
                if (event.target === modal) {
                    modal.style.display = 'none';
                }
            });
        });
    });
}

export default sustainability;
